const PageTitle = (props) => {
    const { title, subtitle, bannerImage } = props;
    return (
        <>
            <section className="page-banner">
                <div className="banner-image">
                    <img src={bannerImage} width="100%" alt="" />
                </div>
                <div className="site-container page-banner-content">
                    <div className="sub-heading txt-clr-white mb-3">{subtitle}</div>
                    <div className="heading txt-clr-white">{title}</div>
                </div>
            </section>
        </>
    )
}
export default PageTitle;